import { formatDecimal, formatInteger, formatPercent, formatPeriod, isNumber } from './piFormat.js';
import { safeInternalRoute } from './piNavigation.js';

export const OPEN_STATUSES = ['', 'open', 'new', 'active'];

const STATUS_LABELS = {
  open: 'Aberto',
  new: 'Aberto',
  active: 'Aberto',
  acked: 'Visto',
  ack: 'Visto',
  seen: 'Visto',
  acknowledged: 'Visto',
  dismissed: 'Descartado',
  resolved: 'Resolvido',
  expired: 'Expirado',
};

const CONFIDENCE_LABELS = { high: 'alta', medium: 'média', low: 'baixa' };

const text = (value) => (typeof value === 'string' ? value.trim() : '');

const statusKey = (status) => text(status).toLowerCase();

export const isOpenInsight = (status) => OPEN_STATUSES.indexOf(statusKey(status)) !== -1;

export const insightStatusLabel = (status) => {
  const key = statusKey(status);
  if (!key) return STATUS_LABELS.open;
  return Object.prototype.hasOwnProperty.call(STATUS_LABELS, key) ? STATUS_LABELS[key] : status;
};

export const confidenceLabel = (confidence) => {
  if (isNumber(confidence)) return confidence <= 1 ? formatPercent(confidence * 100, 0) : formatDecimal(confidence, 1);
  const key = statusKey(confidence);
  if (!key) return '';
  return Object.prototype.hasOwnProperty.call(CONFIDENCE_LABELS, key) ? CONFIDENCE_LABELS[key] : text(confidence);
};

export const insightMeta = (insight) => {
  const source = insight || {};
  const parts = [];
  if (source.periodFrom && source.periodTo) parts.push('Período ' + formatPeriod(source.periodFrom, source.periodTo));
  if (isNumber(source.sampleSize)) parts.push('amostra ' + formatInteger(source.sampleSize));
  const confidence = confidenceLabel(source.confidence);
  if (confidence) parts.push('confiança ' + confidence);
  if (isNumber(source.impactedUsers)) parts.push(formatInteger(source.impactedUsers) + (source.impactedUsers === 1 ? ' usuário impactado' : ' usuários impactados'));
  if (isNumber(source.impactedCompanies)) parts.push(formatInteger(source.impactedCompanies) + (source.impactedCompanies === 1 ? ' empresa impactada' : ' empresas impactadas'));
  return parts.join(' · ');
};

export const insightView = (insight, override) => {
  const source = insight || {};
  const status = override && typeof override.status === 'string' ? override.status : source.status;
  return {
    id: source.id === undefined || source.id === null ? '' : String(source.id),
    title: text(source.title) || 'Insight sem título',
    observation: text(source.observation),
    hypothesis: text(source.hypothesis),
    nextStep: text(source.nextStep),
    route: safeInternalRoute(source.linkRoute),
    companyName: text(source.companyName),
    open: isOpenInsight(status),
    statusText: insightStatusLabel(status),
    metaText: insightMeta(source),
    busy: !!(override && override.busy),
    error: override && override.error ? override.error : '',
  };
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piInsights.js